import React, {Component} from "react"
import styled from "styled-components"

import UserSearch, {UserSelectOnChange} from "@irati/ui/src/UserSearch"
import {FormattedMessage} from "@irati/utils/lang"
import {User} from "@irati/types"
import padding from "@irati/ui/src/global/padding"
import tracking from "@irati-tracking/wallet/tenantWallet"

import SelectedManager from "../SelectedManager"

const StyledRow = styled.div`
  margin-bottom: ${padding.tiny};
  padding-bottom: 10px;
`

const FlexRow = styled.div`
  display: flex;
  .form-group {
    width: 100%;
  }
  .col-xs-12 {
    padding: 0px;
  }
`

interface Props {
  addRecipient(user: User): void
  recipients: User[]
  removeRecipient(user: User): void
}

interface State {
  hasTrackingEventFired: boolean
}

class SelectManager extends Component<Props, State> {
  state: State = {
    hasTrackingEventFired: false
  }

  handleClick = () => {
    if (!this.state.hasTrackingEventFired) {
      tracking.updateRefundManager()
      this.setState({hasTrackingEventFired: true})
    }
  }

  handleSelectUser: UserSelectOnChange = (_, user) => {
    if (user) {
      this.props.addRecipient(user)
    }
  }

  render() {
    const {recipients, removeRecipient} = this.props

    if (recipients.length > 0) {
      return (
        <>
          <StyledRow>
            <FormattedMessage id="wallet.tenant.refund.selected.title" />
          </StyledRow>
          <SelectedManager key={recipients[0].uuid} index={0} removeUser={removeRecipient} user={recipients[0]} />
        </>
      )
    }
    return (
      <FlexRow onClick={this.handleClick}>
        <UserSearch
          id="tenantWalletRefundManagerSelector"
          label="wallet.tenant.refund.managerLabel"
          placeholder="wallet.tenant.recipients.placeholder"
          onChange={this.handleSelectUser}
          controlShouldRenderValue={false}
        />
      </FlexRow>
    )
  }
}

export default SelectManager
